import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  provideLocalMetricStorage,
  provideMetricOnStartup,
} from '@mds/ngx-diagnostics';

export function provideMetrics(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideLocalMetricStorage('MDS_METRIC_STORAGE'),
    provideMetricOnStartup(60000),
  ]);
}
